var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvalop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7002 6.25V16.75C20.7002 17.3467 20.4631 17.919 20.0412 18.341C19.6192 18.7629 19.0469 19 18.4502 19H3.4502C2.85346 19 2.28116 18.7629 1.85921 18.341C1.43725 17.919 1.2002 17.3467 1.2002 16.75V6.25M20.7002 6.25C20.7002 5.65326 20.4631 5.08097 20.0412 4.65901C19.6192 4.23705 19.0469 4 18.4502 4H3.4502C2.85346 4 2.28116 4.23705 1.85921 4.65901C1.43725 5.08097 1.2002 5.65326 1.2002 6.25M20.7002 6.25V6.493C20.7002 6.87715 20.6019 7.25491 20.4146 7.5903C20.2273 7.92569 19.9573 8.20754 19.6302 8.409L12.1302 13.024C11.7754 13.2425 11.3669 13.3582 10.9502 13.3582C10.5335 13.3582 10.125 13.2425 9.7702 13.024L2.2702 8.41C1.94312 8.20854 1.67306 7.92669 1.48576 7.5913C1.29846 7.25591 1.20015 6.87815 1.2002 6.494V6.25",
    stroke: "#798CAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvalop);
export default __webpack_public_path__ + "static/media/envalop.dd2049adfbd61ada36c6adc95b1d5600.svg";
export { ForwardRef as ReactComponent };